import channels from "@/modules/channels"
import auth from "@/modules/auth"
import post from "@/modules/post"
import user from "@/modules/users"
import shops from "@/modules/shops"
import statistic from "@/modules/statistic"
import catalog from "@/modules/catalog"
import complaints from "@/modules/complaints"
import promopushka from "@/modules/promopushka"
import comment from "@/modules/comments"
import promocodes from "@/modules/promocodes"
import wishlist from "@/modules/wishlist"

export default class Module {
  static handle(app) {
    app.use(channels)
    app.use(auth)
    app.use(post)
    app.use(user)
    app.use(shops)
    app.use(statistic)
    app.use(catalog)
    app.use(complaints)
    app.use(promopushka)
    app.use(comment)
    app.use(promocodes)
    app.use(wishlist)
  }
}
